import type { FunctionComponent } from 'react';
import React from 'react';

import { PartnerParams } from '@jerry-serverless/analyticslib/partner';

import { makeScript } from '../script';

/**
 *
 */
function jR(ctx) {
  /*eslint-disable */
  function gup(r) {
    for (var a = window.location.search.slice(1).split('&'), e = 0; e < a.length; e += 1) {
      var o = a[e].split('=');
      if (o[0] === r) return o[1];
    }
  }
  function gpc(r) {
    /**
     * If "r" is an empty string, we should return directly, not return the "a" below (the "a" will be an empty object).
     * the empty object will recover the existed cookie, it's unexpected.
     */
    if (!r) return;
    for (var a = {}, e = 0; e < ctx.partnerParams.global.length; e += 1) {
      (n = gup((c = ctx.partnerParams.global[e]))) && (a[c] = n);
    }
    for (var o = ctx.partnerParams[r.replace(/^p/i, '')] || [], t = 0; t < o.length; t += 1) {
      var c, n;
      (n = gup((c = o[t]))) && (a[c] = n);
    }
    return a;
  }
  function sc(r, a) {
    document.cookie = r + '=' + encodeURIComponent(a) + '; domain=; path=/; max-age=31536000';
  }
  // Must use var, because const will be transpiled to var in client, which would cause SSR diff.
  var jrcod =
    gup('utm_source') || (gup('code') ? 'u' + gup('code') : '') || (gup('partner') ? 'p' + gup('partner') : '');
  var jrdat = gpc(jrcod);
  var jrsrc = document.referrer;
  jrcod.match(
    /^[u|p].+|^facebook$|^tiktok$|^youtube$|^googlebrand$|^qw$|^everquote$|^smartfinancial$|^gasbuddy$|^gasbuddyapp$|^gasbuddyemail$|^gasbuddyalt$|^$/i
  ) && (jrcod && sc('jrcod', jrcod), jrdat && sc('jrdat', JSON.stringify(jrdat))),
    jrsrc && -1 !== jrsrc.search(/https?:\/\/(.+?\.)?facebook\.com*/) && sc('jrsrc', jrsrc);
  /*eslint-enable */
}

export const JerryReferrerScript: FunctionComponent<unknown> = () => {
  return <>{makeScript(jR, { partnerParams: PartnerParams })}</>;
};

export default JerryReferrerScript;
